/* This example requires Tailwind CSS v2.0+ */
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Hero from "components/organisms/common/Hero"
import useTranslations from "hooks/useTranslations"

// pro/pexels-andrea-piacquadio-3866632.jpeg
// schools/AdobeStock_195624071.jpeg
// schools/AdobeStock_576257341.jpeg
// schools/pexels-fox-1595391.jpeg

const HeroImage = ({ className }) => {
  const data = useStaticQuery(graphql`
    {
      hero: file(relativePath: { eq: "schools/AdobeStock_576257341.jpeg" }) {
        childImageSharp {
          gatsbyImageData(quality: 90)
        }
      }
    }
  `)

  return (
    <GatsbyImage
      loading="eager"
      image={getImage(data.hero)}
      className={className}
      imgStyle={{
        objectFit: "cover",
        objectPosition: "top",
      }}
    />
  )
}

export default function HeroCourses() {
  const {
    schoolHeroHighlight,
    schoolsTrainingHeroTitle,
    schoolsTrainingHeroDescription,
  } = useTranslations()
  return (
    <Hero
      Image={HeroImage}
      slides={[schoolsTrainingHeroTitle]}
      description={schoolsTrainingHeroDescription}
      bgColor="yellow"
      searchWords={schoolHeroHighlight || [""]}
      flipImage={false}
      buttonType="contact"
    />
  )
}
